var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApiAccessAudit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "apiaccessaudit-a",
  points: "0 -.001 12.037 -.001 12.037 9 0 9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 10)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "apiaccessaudit-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#apiaccessaudit-a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.1133,4.5 C7.1133,3.879 6.6233,3.375 6.0183,3.375 C5.4143,3.375 4.9253,3.879 4.9253,4.5 C4.9253,5.121 5.4143,5.625 6.0183,5.625 C6.6233,5.625 7.1133,5.121 7.1133,4.5 M6.0183,7.313 C4.5083,7.313 3.2833,6.053 3.2833,4.5 C3.2833,2.947 4.5083,1.687 6.0183,1.687 C7.5293,1.687 8.7553,2.947 8.7553,4.5 C8.7553,6.053 7.5293,7.313 6.0183,7.313 M11.6403,3.603 L8.7383,1.042 C7.1633,-0.348 4.8753,-0.348 3.3003,1.042 L0.3963,3.603 C-0.1317,4.07 -0.1317,4.93 0.3963,5.397 L3.3003,7.958 C4.8753,9.348 7.1633,9.348 8.7383,7.958 L11.6403,5.397 C12.1703,4.93 12.1703,4.07 11.6403,3.603",
  mask: "url(#apiaccessaudit-b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.2764,10.0386 C3.8444,10.0386 3.4144,10.2036 3.0854,10.5326 C2.4264,11.1906 2.4264,12.2576 3.0854,12.9146 C3.4144,13.2446 3.8444,13.4086 4.2764,13.4086 C4.7074,13.4086 5.1384,13.2446 5.4674,12.9146 C6.1264,12.2576 6.1264,11.1906 5.4674,10.5326 C5.1384,10.2036 4.7074,10.0386 4.2764,10.0386"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M10.7187 8.8555L10.7057 7.0815 12.4797 7.0945 13.3607 6.2135 13.3477 4.4395 15.1207 4.4535 15.8207 3.7545C15.9367 3.6375 16.0007 3.4795 15.9997115 3.3135L15.9807.6495C15.9777.3045 15.6967.0225 15.3507.0195L12.6867.000488455614C12.5207-.0005 12.3627.0635 12.2457.1795L6.2647 6.1615M6.2646 6.1611C4.5896 5.7071 2.7436 6.1071 1.4436 7.4081-.5024 9.3521-.4774 12.5301 1.4956 14.5041 2.9766 15.9841 5.1336 16.3681 6.9406 15.6461"
}))));
export default SvgApiAccessAudit;